/**
 * @module app.shared
 */

import { autoinject, bindingMode, customAttribute } from 'aurelia-framework';
import { TestIdService } from 'app/shared/services/test-id-service';
import { TestIdCustomAttribute } from 'app/shared/attributes/test-id-attribute';
import { EnvironmentService } from 'app/shared/services/environment-service';

@autoinject
@customAttribute('test-group', bindingMode.twoWay)
export class TestGroupCustomAttribute extends TestIdCustomAttribute {

    constructor(element: Element, idService: TestIdService, env: EnvironmentService) {
        super(element, idService, env);
    }

    protected buildTestId(name: string): string {
        if(!name) { return ''; }
        return `grp-${name}`;
    }

}
